var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", [
      _vm._v("© "),
      _c("a", { attrs: { href: "https://www.stea.fi", target: "_blank" } }, [
        _vm._v("STEA")
      ]),
      _vm._v(" " + _vm._s(_vm.$t("PageTitle")))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }